var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSidebarMiniStaging(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 126,
    viewBox: "0 0 155 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 63.1823,
    cy: 62.5901,
    r: 62.53,
    fill: "#9EA2FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.067,
    cy: 73.2788,
    r: 14.2368,
    fill: "#9EA2FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.613 59.0428C109.988 59.1594 97.3566 71.8622 97.3566 87.5157H68.8829C68.8829 58.9714 89.8841 35.332 117.278 31.2063C122.083 39.4704 125.048 48.9361 125.613 59.0428ZM48.0264 87.5157C48.0264 71.7898 60.7745 59.042 76.5001 59.042V30.5684C45.1095 30.5684 19.6509 55.9666 19.553 87.3342L48.0264 87.5157Z",
    fill: "#383ECD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSidebarMiniStaging);
export default __webpack_public_path__ + "static/media/logo-sidebar-mini-staging.ee1f96e95dd34488704846346fea1927.svg";
export { ForwardRef as ReactComponent };